import { log } from "@dustin-web/microsite-config/src/logger";

export const createOptimizelyEventDispatcher = (hasAnalyticsConsent: boolean) => ({
  dispatchEvent: ({ url, httpVerb, params }: { url: string; httpVerb: string; params: Record<string, string> }) => {
    // Override the URL with the proxy URL / CNAME (without https in that case)
    // url = 'http://logx.optimizely.demo.training/v1/events'

    if (!hasAnalyticsConsent) {
      return
    }

    fetch(url, {
      method: httpVerb,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    }).catch(_ => {
      log.warn('Failed to send Optimizely event')
    })
  },
})
